import * as React from "react";
import { clsx, cssVar } from "../../core/index.js";
import { useCaptions } from "./CaptionsContext.js";
import { cssPrefix } from "./utils.js";
export const Title = ({ title, styles }) => {
    const { toolbarWidth } = useCaptions();
    return (React.createElement("div", { style: styles.captionsTitleContainer, className: clsx(cssPrefix("captions_container"), cssPrefix("title_container")) },
        React.createElement("div", { style: styles.captionsTitle, className: cssPrefix("title"), ...(toolbarWidth ? { style: { [cssVar("toolbar_width")]: `${toolbarWidth}px` } } : null) }, title)));
};
